<template lang="pug">
    article.policy
        .policy__wrap(v-observe-visibility='visibilityChanged')
            .policy__text
                .h1.h1--color-main.policy__title Политика конфиденциальности
                .policy__subtitle
                    p.
                        Политика конфиденциальности определяет политику Оператора в отношении обработки Данных соискателей,
                        а также содержит сведения о реализуемых требованиях к защите персональных данных соискателей.
                .policy__item
                    h2.h2 1. ТЕРМИНЫ
                    p.
                        1.1. <strong>Оператор</strong> – юридическое лицо, осуществляющее обработку Данных Соискателей:
                        Общество с ограниченной ответственностью «Бизнес Решения Интертеймент» (ООО «БРИ»,
                        ОГРН 1037725059800; адрес: 117105, г. Москва, Варшавское ш., д. 9, стр. 1, помещ. А, ком. 37).
                    p.
                        1.2. <strong>Соискатели</strong> – кандидаты, претендующие на замещение вакантных должностей (как имеющихся,
                        так и открываемых в будущем).
                    p 1.3. <strong>Данные</strong> – персональные данные Соискателя, а также иная относящаяся к нему информация.

                .policy__item
                    h2.h2 2. ДЕЙСТВИЕ ПОЛИТИКИ
                    p.
                        2.1. Взаимодействуя с Оператором в рамках указанной в п. 3.1 Политики цели (в том числе откликаясь
                        на вакантную должность, размещенную Оператором; направляя заявку, резюме или иные Данные),
                        Соискатель соглашается с условиями обработки Данных Оператором, описанными в настоящей Политике
                        конфиденциальности (Политика). В случае несогласия с такими условиями обработки Соискатель не должен
                        осуществлять указанное взаимодействие с Оператором.
                    p.
                        2.2. Политика может быть изменена Оператором. Измененная Политика доступна на сайте rambler-co.ru/career
                        (раздел «Карьера»). Откликаясь на вакантную должность, размещенную Оператором, или иным образом
                        взаимодействуя с Оператором в рамках указанной в п. 3.1 Политики цели после изменения Политики,
                        Соискатель соглашается с измененными условиями обработки Данных.
                .policy__item
                    h2.h2 3. ЦЕЛЬ И УСЛОВИЯ ОБРАБОТКИ
                    p.
                        3.1. Оператор обрабатывает Данные с целью <strong>принятия решения о возможности замещения вакантных
                        должностей, включая формирование и ведение кадрового резерва</strong>, в том числе:
                    ul
                        li получение информации о вакантных должностях, в том числе посредством указанных Соискателем контактных данных;
                        li обсуждение условий дальнейшего сотрудничества;
                        li прием обращений Соискателей и предоставление ответов на указанные обращения;
                        li исследование достоверности сведений, предоставленных Соискателем (если применимо).
                    p.
                        В указанной цели Оператор обрабатывает следующие Данные: фамилия, имя, отчество; пол; дата рождения;
                        адрес места жительства; номер телефона; адрес электронной почты; профессия; должность; доходы;
                        сведения об образовании; сведения о трудовой деятельности; фотография; сведения из резюме; сведения из портфолио.
                    p.
                        3.2. Для цели, указанной в п. 3.1. Политики, применимы следующие условия обработки:
                    p.
                        3.2.1. Оператором не обрабатываются биометрические и специальные категории персональных данных
                        Соискателей. Обрабатываемые Оператором персональные данные относятся к иным категориям персональных данных.
                    p.
                        3.2.2. Способы обработки Данных: сбор, запись, систематизация, накопление, хранение, уточнение
                        (обновление, изменение), извлечение, использование, передача (предоставление, доступ),
                        обезличивание, блокирование, удаление и уничтожение.
                    p.
                        3.2.3. Срок обработки и хранения Данных: до достижения цели обработки, до истечения срока
                        действия согласия или до отзыва согласия (если отсутствуют иные основания для обработки таких Данных),
                        в зависимости от того, какое событие наступило раньше.
                    p.
                        3.3. Соглашаясь с условиями обработки Данных, изложенными в Политике, Соискатель в том числе
                        соглашается с целью, указанной в п. 3.1. Политики:
                    p.
                        3.3.1. на передачу (предоставление, доступ) партнерам Оператора, с которыми у Оператора заключен
                        договор на поиск и подбор кандидатов на вакантные должности (далее – «Партнеры») и их последующую
                        обработку Партнерами. Информация о соответствующем Партнере предоставляется Оператором в том числе
                        посредством указанных Соискателем контактных данных.
                    p.
                        3.3.2. на обработку провайдерами услуг, необходимых для осуществления обработки Данных в
                        указанной цели, в частности хостинг-провайдером (ООО «РИХ»), по поручению Оператора.
                    p.
                        3.4. Оператор обязуется обеспечить запись, систематизацию, накопление, хранение, уточнение
                        (обновление, изменение), извлечение персональных данных Соискателей с использованием баз данных,
                        находящихся на территории РФ.
                .policy__item
                    h2.h2 4. ОСНОВАНИЯ ОБРАБОТКИ
                    p Правовыми основаниями обработки Данных Оператором являются в том числе:
                    ul
                        li согласие Соискателя;
                        li заключение договора с Соискателем;
                        li осуществление прав и законных интересов Оператора или третьих лиц, если при этом не нарушаются права и свободы Соискателя;
                        li.
                            необходимость обработки для достижения целей, предусмотренных законом, а также выполнение
                            обязанностей, возложенных на Оператора законодательством.
                .policy__item
                    h2.h2 5. ПРАВА СОИСКАТЕЛЯ
                    p Соискатель вправе:
                    ul
                        li получать информацию, касающуюся обработки своих Данных;
                        li.
                            требовать от Оператора уточнения его Данных, их блокирования или уничтожения в случае, если
                            они неполные, устаревшие, неточные, незаконно полученные или не являются необходимыми для заявленной цели обработки;
                        li отозвать согласие на обработку своих Данных, направив Оператору заявление в письменной форме;
                        li принимать предусмотренные законодательством РФ меры по защите своих прав.
                .policy__item
                    h2.h2 6. ПОЛОЖЕНИЕ О КАДРОВОМ РЕЗЕРВЕ
                    p.
                        6.1. Кадровый резерв ведется Оператором с целью формирования высокопрофессионального кадрового
                        состава Оператора и Партнеров и в рамках выполнения следующих задач: своевременный подбор сотрудников
                        на вакантные должности и информирование Соискателей о вакантных должностях.
                    p.
                        6.2. Общие принципы создания кадрового резерва:
                    ul
                        li добровольность включения;
                        li равенство прав и возможностей Соискателей, в том числе недопущение дискриминации;
                        li соблюдение Оператором требований применимого законодательства.
                    p.
                        6.3. Перечень должностей, в отношении которых образуется кадровый резерв, определяется Оператором
                        и/или Партнерами. При этом, если не указано иное, в кадровый резерв включаются Соискатели,
                        претендующие на любые вакантные должности.
                    p 6.4. Порядок формирования и обновления кадрового резерва Оператором:
                    p.
                        6.4.1. Оператор размещает информацию о вакантных должностях любыми доступными способами, в том
                        числе на сайте rambler-co.ru/career (раздел «Карьера).
                    p.
                        6.4.2. Оператор осуществляет поиск, прием заявок Соискателей и оценку наиболее подходящих
                        кандидатов на вакантные должности на свое усмотрение.
                    p.
                        6.4.3. Оператор формирует и обновляет кадровый резерв по мере открытия/закрытия вакантных
                        должностей, получения заявок Соискателей, дополнительного запроса информации у Соискателей для
                        ее актуализации, а также исключения Соискателей из кадрового резерва.
                    p.
                        6.5. Соглашаясь с условиями обработки Данных, изложенными в Политике, Соискатель
                        соглашается на его включение в кадровый резерв.
                    p 6.6. Порядок исключения Соискателя из кадрового резерва:
                    p.
                        6.6.1. Срок нахождения Соискателя в кадровом резерве составляет пять лет, если Соискатель
                        не будет ранее исключён из кадрового резерва по собственной инициативе в соответствии с п. 6.6.2 Политики.
                    p.
                        6.6.2. Соискатель вправе в любое время самостоятельно обратиться к Оператору с письменным
                        заявлением об исключении из кадрового резерва.
                    p.
                        6.6.3. В отсутствие соответствующего правового основания обработки Данных Оператор уничтожает
                        Данные в соответствии с условиями раздела 7 Политики.
                .policy__item
                    h2.h2 7. ПОРЯДОК УНИЧТОЖЕНИЯ
                    p.
                        7.1. В отношении Данных, обрабатываемых Оператором в указанной в п. 3.1. Политики цели,
                        действует единый порядок их уничтожения в соответствии с законодательством РФ и локальными нормативными актами Оператора.
                    p.
                        7.2. Данные подлежат уничтожению Оператором, в частности, если достигнута цель обработки или
                        Соискателем отозвано согласие на их обработку (и отсутствуют иные основания для обработки таких Данных),
                        либо выявлен факт их неправомерной обработки.
                    p.
                        7.3. В случае достижения цели обработки Данных Оператор прекращает их обработку и уничтожает их
                        в срок, не превышающий 30 дней с даты достижения цели обработки. В случае отзыва Соискателем
                        согласия на обработку его Данных, Оператор прекращает их обработку и в случае, если сохранение
                        Данных более не требуется для цели обработки, уничтожает их в срок, не превышающий 30 дней с
                        даты поступления указанного отзыва.
                    p.
                        7.4. В случае выявления неправомерной обработки персональных данных, осуществляемой Оператором,
                        Оператор в срок, не превышающий 3 рабочих дней с даты этого выявления, прекращает такую обработку.
                        В случае, если обеспечить правомерность такой обработки невозможно, Оператор в срок, не превышающий
                        10 рабочих дней с даты выявления неправомерной обработки, уничтожает такие Данные. При этом Оператор
                        уведомляет Соискателя об устранении допущенных нарушений или об уничтожении Данных.
                .policy__item
                    h2.h2 8. СВЕДЕНИЯ О РЕАЛИЗУЕМЫХ ТРЕБОВАНИЯХ К ЗАЩИТЕ
                    p 8.1. Оператор обязуется обеспечивать конфиденциальность персональных данных Соискателя.
                    p.
                        8.2. Оператор обеспечивает безопасность персональных данных Соискателей посредством
                        реализации правовых, организационных и технических мер.
                    p 8.2.1. Правовые меры, принимаемые Оператором, включают:
                    ul
                        li.
                            издание Оператором документов, определяющих политику оператора в отношении обработки
                            персональных данных, локальных актов по вопросам обработки персональных данных, а также
                            локальных актов, устанавливающих процедуры, направленные на предотвращение и выявление
                            нарушений законодательства РФ, устранение последствий таких нарушений.
                    p 8.2.2. Организационные меры, принимаемые Оператором, включают:
                    ul
                        li.
                            обеспечение неограниченного доступа к Политике, к сведениям о реализуемых требованиях к
                            защите персональных данных;
                        li.
                            осуществление внутреннего контроля и (или) аудита соответствия обработки персональных
                            данных Федеральному закону от 27.07.2006 N 152-ФЗ «О персональных данных» (Закон) и принятым
                            в соответствии с ним нормативным правовым актам, требованиям к защите персональных данных,
                            политике Оператора в отношении обработки персональных данных, локальным актам Оператора;
                        li.
                            оценка вреда, который может быть причинен субъектам персональных данных в случае нарушения
                            Закона, соотношение указанного вреда и принимаемых Оператором мер, направленных на
                            обеспечение выполнения обязанностей, предусмотренных Законом;
                        li.
                            ознакомление работников Оператора, непосредственно осуществляющих обработку персональных
                            данных, с положениями законодательства РФ о персональных данных, в том числе требованиями
                            к защите персональных данных, документами, определяющими политику Оператора в отношении
                            обработки персональных данных, локальными актами по вопросам обработки персональных данных,
                            и (или) обучение указанных работников;
                        li назначение лица, ответственного за организацию обработки персональных данных;
                        li.
                            назначение лица, ответственного за обеспечение безопасности персональных данных в
                            информационных системах персональных данных (ИСПДн);
                        li.
                            утверждение руководителем Оператора документа, определяющего перечень лиц, доступ которых
                            к персональным данным, обрабатываемым в ИСПДн, необходим для выполнения ими служебных (трудовых) обязанностей;
                        li обеспечение сохранности носителей персональных данных;
                        li учет машинных носителей персональных данных;
                        li определение угроз безопасности персональных данных при их обработке в ИСПДн;
                        li.
                            организация контролируемой зоны, в пределах которой постоянно размещаются стационарные
                            технические средства, обрабатывающие информацию, и средства защиты информации, а также
                            средства обеспечения функционирования;
                        li.
                            организация режима обеспечения безопасности помещений, в которых размещена ИСПДн,
                            препятствующего возможности неконтролируемого проникновения или пребывания в этих помещениях
                            лиц, не имеющих права доступа в эти помещения.
                    p.
                        8.2.3. Технические меры, принимаемые Оператором, включают:
                    ul
                        li.
                            использование средств защиты информации, прошедших процедуру оценки соответствия требованиям
                            законодательства РФ в области обеспечения безопасности информации, в случае, когда применение
                            таких средств необходимо для нейтрализации актуальных угроз;
                        li оценку эффективности принимаемых мер по обеспечению безопасности персональных данных до ввода в эксплуатацию ИСПДн;
                        li.
                            установление правил доступа к персональным данным, обрабатываемым в ИСПДн, а также обеспечением
                            регистрации и учета всех действий, совершаемых с персональными данными в ИСПДн;
                        li.
                            обнаружение фактов несанкционированного доступа к персональным данным и принятием мер, в
                            том числе мер по обнаружению, предупреждению и ликвидации последствий компьютерных атак на
                            ИСПДн и по реагированию на компьютерные инциденты в них;
                        li.
                            восстановление персональных данных, модифицированных или уничтоженных вследствие несанкционированного доступа к ним;
                        li.
                            контроль за принимаемыми мерами по обеспечению безопасности персональных данных и уровня защищенности ИСПДн.
                .policy__item
                    h2.h2 9. ИНОЕ
                    p.
                        9.1. Соискатель несет ответственность за правомерность предоставления, актуальность и достоверность
                        данных и иных лиц, которые Соискатель предоставляет Оператору.
                    p.
                        9.2. Оператор рассматривает обращения, связанные с Политикой, включая запросы Соискателей
                        относительно использования их Данных по адресу: 117105, Россия, г. Москва, Варшавское шоссе, д. 9, стр. 1.
                .policy__item
                    p.text-right.text-italic Редакция от 01 сентября 2022

        Footer

</template>

<script>
import weData from '../assets/data/we.json';
import Footer from '../components/Footer.vue';
import NextPageTrigger from '../components/NextPageTrigger.vue';
import NextPageHelper from '../components/NextPageHelper.vue';
import BlockVisibilityTrigger from '../components/BlockVisibilityTrigger.vue';

export default {
    name: 'We',

    components: {
        Footer,
        NextPageTrigger,
        NextPageHelper,
        BlockVisibilityTrigger
    },

    data() {
        return {
            we: weData,
            reachEndTrigger: false,
            reachStartTrigger: false
        };
    },

    beforeMount() {},

    mounted() {},

    methods: {
        visibilityChanged(e, el) {
            if (e) {
                el.target.classList.add('show');
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../assets/css/vars.scss';
@import '../assets/css/base.scss';
@import '../assets/css/animations.scss';

:root {
    --vh: 5.68px;
}

.policy {
    background-color: var(--color-main-bg);
    padding-top: 2.8em;

    @media (--viewport-tablet) {
        padding-top: 2.8em;
    }

    &__wrap {
        padding-top: 2.8em;
    }

    &__text-box,
    &__logo,
    &__system {
        width: calc(var(--layout-column-width) * 6 + var(--layout-gutter-width) * 5);
        margin: 0 auto;

        @media (--viewport-tablet) {
            width: calc(var(--layout-column-width) * 10 + var(--layout-gutter-width) * 9);
        }
    }

    &__title {
        text-align: left;
        margin-bottom: 1.3em;

        $mapFontSize: (
            375px: 26px,
            1440px: 36px,
            1920px: 42px
        );
        @include poly-fluid-sizing('font-size', $mapFontSize);
    }

    &__subtitle {
        font-style: italic;
        .policy & {
            margin-bottom: 2em;
        }
    }

    h2.h2 {
        font-size: 1.4em;
        font-weight: 700;
        line-height: 1.2;
        text-transform: uppercase;
        margin-bottom: 0.6em;
    }

    &__text {
        margin-bottom: 3em;
        max-width: calc(var(--layout-column-width) * 6 + var(--layout-gutter-width) * 5);
        margin-left: auto;
        margin-right: auto;

        @media (--viewport-tablet) {
            max-width: calc(var(--layout-column-width) * 10 + var(--layout-gutter-width) * 9);
        }

        &::v-deep p {
            margin-bottom: 1em;
        }

        &--min-margin {
            margin-bottom: 1em;
        }

        &--small {
            font-size: 0.6em;
            text-align: center;
        }
    }

    &__item:not(:last-child) {
        margin-bottom: 25px;
    }

    p:not(:last-child) {
        margin-bottom: 15px;
    }

    ul {
        padding-left: 12px;
        margin-bottom: 15px;
    }

    li {
        list-style: disc;
    }

    .text-right {
        text-align: right;
    }

    .text-italic {
        font-style: italic;
    }
}
</style>
